import CardHeader from "components/CardHeader";
import { ApexOptions } from 'apexcharts';
import { Expense } from 'models/Expense';
import { Invoice } from 'models/Invoice';
import { AccountableContainer, FilterExternalInvoices, FilterFinalInvoices } from 'models/InvoiceContainer';
import React from 'react';
import ReactApexChart from "react-apexcharts"
import { connect } from 'react-redux';
import { Card, CardBody } from 'reactstrap';
import { InvoiceState } from 'store/reducers/Invoices';
import { ExpenseState } from 'store/reducers/Expenses';
import { RootState } from 'store/store';
import { CustomerState } from "../../store/reducers/Customers";
import { useOfficeTranslation } from "i18n/OfficeTranslation";

interface Props {
    invoiceState: InvoiceState;
    expenseState: ExpenseState;
    customerState: CustomerState;
}

interface OwnProps { months?: number; }

const SalesAnalytics: React.FC<Props & OwnProps> = ({ months = 12, customerState, invoiceState, expenseState }) => {
    const { t } = useOfficeTranslation();

    const ic = (new AccountableContainer<Invoice>(invoiceState.getInvoices()))
        .Filter(FilterExternalInvoices)
        .Filter(FilterFinalInvoices)

    const ec = (new AccountableContainer<Expense>(expenseState.getExpenses().filter(exp => {
        if (exp.name.length === 36) {
            const inv = invoiceState.getInvoiceById(exp.name)
            if (inv !== null) {
                const customer = customerState.getCustomerById(inv.customer)
                return customer !== null
            }
        }
        return true;
    })))

    var series: ApexAxisChartSeries = [
        {
            name: t("common.revenue"),
            type: 'column',
            data: ic
                .EveryMonth(months)
                .CalcTotal(invoice => invoice.CalcTotalContents())
                .map((rev) => Math.floor(rev))
        },
        {
            name: t("common.expenses"),
            type: 'column',
            data: ec
                .EveryMonth(months)
                .CalcTotal(expense => expense.total - expense.tax)
                .map((rev) => Math.floor(rev))
        },
        // {
        //     name: 'Conversation Ratio',
        //     type: 'area',
        //     data: [44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43]
        // },
        // {
        //     name: 'Invoices',
        //     type: 'line',
        //     data: ic.EveryMonth(12).Count()
        // }
    ];
    var options: ApexOptions = {
        chart: {
            height: 338,
            type: 'line',
            stacked: !1,
            offsetY: -5,
            toolbar: {
                show: !1
            }
        },
        stroke: {
            width: 1,
            curve: 'smooth'
        },
        plotOptions: {
            bar: {
                columnWidth: '40%'
            }
        },
        colors: ['#2cb57e', '#0576b9', '#dfe2e6', '#f1b44c'],
        fill: {
            opacity: [0.85, 1, 0.25, 1],
            gradient: {
                inverseColors: !1,
                shade: 'light',
                type: "vertical",
                opacityFrom: 0.85,
                opacityTo: 0.55,
                stops: [0, 100, 100, 100]
            }
        },
        labels: ic.EveryMonth(months).GetMonths(),
        markers: {
            size: 0
        },
        yaxis: {
            decimalsInFloat: 0,
        },
        tooltip: {
            shared: !0,
            intersect: !1
        },
        grid: {
            borderColor: '#f1f1f1',
            padding: {
                bottom: 15
            }
        }
    }

    return (
        <Card className="h-100 mb-0 dashboard-widget-card">
            <CardBody>
                <CardHeader title={t("dashboard.salesAnalytics.analytics")} icon="mdi-chart-bar" />
                <div className="pt-3">
                    <ReactApexChart
                        options={options}
                        series={series}
                        type="bar"
                        height="340"
                        dir="ltr"
                        className="apex-charts"
                    />
                </div>
            </CardBody>
        </Card>
    );
}

const mapStateToProps = (state: RootState) => {
    return {
        invoiceState: state.Invoices,
        expenseState: state.Expenses,
        customerState: state.Customers
    };
};

export default connect(mapStateToProps)(SalesAnalytics);
